import React from "react";

const PeseeHeader = ({ competition, userRole, isDemo }) => {
  return (
    <div className="mx-auto mb-6 w-full max-w-[1680px] text-center">
      <p className="text-xs font-bold uppercase tracking-[0.22em] text-orange-600 dark:text-orange-300">
        Organisateur — {userRole}
      </p>

      <h1 className="mx-auto mt-2 max-w-5xl text-3xl font-bold tracking-tight text-slate-950 dark:text-white sm:text-4xl lg:text-5xl">
        Pesées
      </h1>

      <p className="mx-auto mt-2 max-w-3xl text-sm text-slate-600 dark:text-slate-300 sm:text-base">
        {competition?.nom_competition}
      </p>

      {isDemo && (
        <div className="mx-auto mt-4 max-w-3xl rounded-2xl border border-yellow-300/70 bg-yellow-50 px-4 py-3 text-sm font-semibold text-yellow-800 dark:border-yellow-500/30 dark:bg-yellow-500/10 dark:text-yellow-200">
          Mode Démo : utilisez l’import dédié “judokas fictifs”.
        </div>
      )}
    </div>
  );
};

export default PeseeHeader;